import { useState, createContext, useMemo } from 'react';
import { SortDirection } from './types.js';

function useSortState(defaultValue) {
  const [sorting, setSorting] = useState(defaultValue);
  return {
    sorting,
    setSorting
  };
}
const initialValue = {
  sorting: undefined,
  setSorting: state => {
    console.warn('Trying to set to ', state);
  }
};
const SortContext = /*#__PURE__*/createContext(initialValue);
function useSorting(sortParameter, columns, data) {
  const selectedSorter = useMemo(() => {
    const columnToSort = columns.find(column => column.id === (sortParameter === null || sortParameter === void 0 ? void 0 : sortParameter.name));
    return columnToSort === null || columnToSort === void 0 ? void 0 : columnToSort.valueComparator;
  }, [columns, sortParameter === null || sortParameter === void 0 ? void 0 : sortParameter.name]);
  const sortedData = useMemo(() => {
    if (!data || !selectedSorter) {
      return data;
    }

    if ((sortParameter === null || sortParameter === void 0 ? void 0 : sortParameter.direction) === SortDirection.dsc) {
      return [...data].sort(selectedSorter).reverse();
    }

    return [...data].sort(selectedSorter);
  }, [data, selectedSorter, sortParameter === null || sortParameter === void 0 ? void 0 : sortParameter.direction]);
  return sortedData;
}

export { SortContext, useSorting as default, useSortState, useSorting };
//# sourceMappingURL=useSorting.js.map
